import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Login.css';

function Login({ setIsAuthenticated, setUser }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const convaiRef = useRef(null);

  // Add effect to load the ElevenLabs script
  useEffect(() => {
    // Create the script element
    const script = document.createElement('script');
    script.src = 'https://elevenlabs.io/convai-widget/index.js';
    script.async = true;
    script.type = 'text/javascript';
    
    // Create the convai element
    const convaiElement = document.createElement('elevenlabs-convai');
    convaiElement.setAttribute('agent-id', 'crQjNqa0zibqKmKu8d68');
    
    // Append the element to the container
    if (convaiRef.current) {
      convaiRef.current.appendChild(convaiElement);
    }
    
    // Append the script to the document
    document.body.appendChild(script);
    
    // Cleanup on unmount
    return () => {
      document.body.removeChild(script);
      if (convaiRef.current?.contains(convaiElement)) {
        convaiRef.current.removeChild(convaiElement);
      }
    };
  }, []);

  const handleSubmit = async (e) => {
    // Existing submit handler code...
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }

      setUser(data.user);
      setIsAuthenticated(true);
    } catch (err) {
      if (err.message.includes('archived')) {
        setError('This account has been deactivated. Contact support for assistance.');
      } else {
        setError(err.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Login</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          {/* Existing form fields... */}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <div className="forgot-password">
              <Link to="/forgot-password">Forgot password?</Link>
            </div>
          </div>
          <button type="submit" className="auth-button" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <p className="auth-link">
          Don't have an account? <Link to="/register">Register</Link>
        </p>
        
        {/* Add container for ElevenLabs Convai Widget */}
        <div ref={convaiRef} className="elevenlabs-widget-container"></div>
      </div>
    </div>
  );
}

export default Login;